import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TermsPageService } from '../../../+terms/terms-page.service';
import { TermsPageModel } from '../../../+terms/terms-page.model';
import { LoadingMaskService } from '../../../../shared/loading-mask/loading-mask.service';

@Injectable()
export class CopyrightsResolve implements Resolve<TermsPageModel> {
	constructor(private service: TermsPageService,
	            private mask: LoadingMaskService) {
	}

	resolve(route: ActivatedRouteSnapshot): Observable<TermsPageModel> {
		this.mask.addLoading();
		return this.service.getTermsPageModel()
			.map((model: TermsPageModel) => {
				this.mask.removeLoading();
				return model;
			});
	}
}
